'use client';

import { useEffect, useRef } from 'react';

const WIDGET_SRC = 'https://widget.trustbedrijf.nl/w/bd543b68-fcfe-45d9-89cd-e12595b69561.js';

// The badge renders in an open shadow root with inline styles, so page CSS cannot reach it.
// Its accent (#e8611a) is 3.4:1 on the white card; this darkens it to 5.4:1 (WCAG AA).
const CONTRAST_FIX = '[style*="e8611a" i],[style*="232, 97, 26"]{color:#b4490a !important}';

function patchShadowRoots(container: HTMLElement) {
  container.querySelectorAll('*').forEach((node) => {
    const root = node.shadowRoot;
    if (root && !root.querySelector('style[data-contrast-fix]')) {
      const style = document.createElement('style');
      style.dataset.contrastFix = '';
      style.textContent = CONTRAST_FIX;
      root.appendChild(style);
    }
  });
}

export function TrustbedrijfWidget() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || el.querySelector('script')) return;
    const observer = new MutationObserver(() => patchShadowRoots(el));
    observer.observe(el, { childList: true, subtree: true });
    const s = document.createElement('script');
    s.src = WIDGET_SRC;
    s.async = true;
    el.appendChild(s);
    return () => observer.disconnect();
  }, []);

  return <div ref={ref} className="flex justify-center mt-4" />;
}
